export default __webpack_public_path__ + "static/media/keypad.4936b5e0.svg";